/* global femcare */

femcare.product.stash = {

    init: function () {
        this.$stashModal = $('#stashModal');
        if (this.$stashModal.length) {
            this.$cartModal = $('#cartModal');
            this.$menuModal = $('#menuModal');
            this.key = this.$stashModal.attr('data-stash-key');
            this.transferLabel = this.$stashModal.attr('data-transfer-label');

            this.initStash();
            this.initHandlers();
        }
    },

    initStash: function () {
        this.getStash(
            null,
            function (res) {
                var stashItemCount = (res.items && res.items.totalItems) || 0;
                femcare.shared.pubsub.publish('STASH_ITEM_COUNT_UPDATED', stashItemCount);
            },
            null);
    },

    initHandlers: function () {
        this.initOpenStashHandlers();
        this.initCloseStashHandlers();
        this.initStashItemCountHandlers();

        $('.navigation-bar__icon--stash').on('click', this.openStash.bind(this));
        $('.navigation-bar__stash-counter').on('click', this.openStash.bind(this));
        $('.navigation-bar__icon--mobile-stash').on('click', '.icon-heart', this.openStash.bind(this));
        $('.stash__close').on('click', this.closeStash.bind(this));
        $('.navigation-bar__icon--mobile-stash').on('click', '.icon-close', this.closeStash.bind(this));

        $(window).on('resize', $.proxy(this.onResizeHideStashModal, this));

        femcare.shared.pubsub.subscribe('STASH_ITEM_COUNT_UPDATED', function (count) {
            this.updateStashCounter(count);
        }.bind(this));
    },

    initOpenStashHandlers: function () {
        this.$stashModal.on('show.bs.modal', function () {
            if (this.$menuModal.is(':visible')) {
                this.$menuModal.modal('hide');
            }
            if (this.$cartModal.is(':visible')) {
                this.$cartModal.modal('hide');
            }
        }.bind(this));

        this.$stashModal.on('shown.bs.modal', function () {
            if (!femcare.shared.util.isRichNavbarActive()) {
                $('body').css('position', 'fixed');
                $('.navigation-bar').addClass('navigation-bar--overlayed');
                $('.navigation').addClass('navigation--overlayed');
                $('.navigation-bar__icon--mobile-stash i')
                    .removeClass('icon-heart')
                    .addClass('icon-close');
                $('.navigation-bar__icon--mobile-stash .navigation-bar__stash-counter').hide();
            }
        });
    },

    initCloseStashHandlers: function () {
        this.$stashModal.on('hide.bs.modal', function () {
            $('body').css('position', 'static');
            $('.navigation-bar').removeClass('navigation-bar--overlayed');
            $('.navigation').removeClass('navigation--overlayed');
            $('.navigation-bar__icon--mobile-stash i')
                .removeClass('icon-close')
                .addClass('icon-heart');
            $('.navigation-bar__icon--mobile-stash .navigation-bar__stash-counter').show();
        });
    },

    initStashItemCountHandlers: function () {
        this.$stashModal.on('click', '.stash-item__delete', function (e) {
            var $deleteButton = $(e.currentTarget);
            var skuId = $deleteButton.closest('.stash-item').attr('data-sku-id');
            var skuEanId = $deleteButton.closest('.stash-item').attr('data-ean-id');

            this.updateDeleteStashItem(skuId, skuEanId);
        }.bind(this));
    },

    getStash: function (onBefore, onSuccess, onComplete) {
        onBefore && onBefore();

        return $.ajax({
            url: femcare.shared.util.baseUrl + 'ajax/products/product/getFromSession',
            method: 'POST',
            contentType: 'application/json',
            data: JSON.stringify({ key: this.key }),
            success: onSuccess || null,
            complete: onComplete || null
        });
    },

    openStash: function (e) {
        e.preventDefault();

        this.getStash(
            function onBefore() {
                femcare.shared.ui.setLoadingOverlay(true);
            },
            function onSuccess(res) {
                this.renderStash(res);
                this.$stashModal.modal('show');
            }.bind(this),
            function onComplete() {
                femcare.shared.ui.setLoadingOverlay(false);
            });

        // $.ajax({
        //     url: '/json/ajax-get-stash.json',
        //     dataType: 'json',
        //     method: 'GET',
        //     success: function (data) {
        //         this.renderStash(data);
        //         this.$stashModal.modal('show');
        //     }.bind(this)
        // });
    },

    closeStash: function (e) {
        e.preventDefault();
        this.$stashModal.modal('hide');
    },

    onResizeHideStashModal: function () {
        if (
            this.$stashModal.is(':visible') &&
            femcare.shared.util.isRichNavbarActive()
        ) {
            this.$stashModal.modal('hide');
        }
    },

    renderStash: function (data) {
        var hasItems = data.success && data.items;

        this.$stashModal
            .find('.stash__body')
            .toggleClass('stash__body--empty', !hasItems);

        if (hasItems) {
            var stash = data.items;
            var $itemList = this.$stashModal.find('.stash__items');

            $itemList.empty();

            stash.items.forEach(function (item) {
                var $item = $('<li class="stash-item"></li>');
                $item.attr('data-sku-id', item.productSkuId);
                $item.attr('data-ean-id', item.productSkuEan);
                var $media = $('<div class="stash-item__media"></div>');
                var $image = $('<img class="stash-item__image"/>');
                $image.attr('src', item.image.url);
                $media.append($image);

                var $info = $('<div class="stash-item__info"></div>');
                var $name = $('<div class="stash-item__name"></div>');
                $name.text(item.name);

                var $stock = $('<div class="stash-item__stock"></div>');

                var isInStock = item.quantity.max > 0 && item.quantity.available;

                var $message = $('<div class="stash-item__availability"></div>');
                $message.addClass('stash-item__availability--' + (isInStock ? 'in-stock' : 'out-of-stock'));
                $message.text(item.quantity.availability.stockMessage);
                $stock.append($message);

                if (isInStock) {
                    var $transfer = $('<div class="stash-item__transfer"></div>');
                    var $icon = $('<i class="stash-item__icon icon-shopping-bag"></i>');
                    var $label = $('<span class="stash-item__action-label"></span>').text(this.transferLabel);
                    $transfer.append($icon).append($label);
                    $stock.append($transfer);
                    var $total = $('<div class="stash-item__total">' + item.priceInformation.total + '</div>');
                    $stock.append($total);
                }

                $info.append($name);
                $info.append($stock);

                var $delete = $('<div class="stash-item__delete"><i class="icon-trash-can"></i></div>');
                $info.append($delete);

                $item.append($media);
                $item.append($info);

                $itemList.append($item);
            }.bind(this));
        }
    },

    updateStashCounter: function (count) {
        $('.navigation-bar__stash-counter').text(count || 0);
        this.$stashModal.find('.stash-indicator__counter').text(count || 0);
    },

    updateDeleteStashItem: function (skuId, skuEan) {

        var data = {
            key: this.key,
            value: {
                ean: skuEan,
                id: skuId,
            }
        };

        femcare.shared.ui.setLoadingOverlay(true);

        $.ajax({
            url: femcare.shared.util.baseUrl + 'ajax/products/product/unstashFromSession',
            method: 'POST',
            contentType: 'application/json',
            data: JSON.stringify(data),
            success: function () {
                this.getStash(
                    function onBefore() {
                        femcare.shared.ui.setLoadingOverlay(true);
                    },
                    function onSuccess(res) {
                        this.renderStash(res);
                    }.bind(this),
                    function onComplete() {
                        femcare.shared.ui.setLoadingOverlay(false);
                    });
            }.bind(this),
            complete: function () {
                femcare.shared.ui.setLoadingOverlay(false);
            }
        });
    }
};